import {OrdersApi} from '@shipwell/corrogo-sdk';
import {configuration} from './configuration';

const ordersApi = new OrdersApi(configuration);

type GetOrdersListParameters = Parameters<typeof ordersApi.listOrders>;
export type GetOrdersListParametersObject = {
  page?: GetOrdersListParameters[0];
  limit?: GetOrdersListParameters[1];
  orderBy?: GetOrdersListParameters[2];
  q?: GetOrdersListParameters[3];
  statusIn?: GetOrdersListParameters[4];
  createdAt?: GetOrdersListParameters[5];
  id?: GetOrdersListParameters[6];
  orderNumber?: GetOrdersListParameters[7];
  name?: GetOrdersListParameters[8];
  references?: GetOrdersListParameters[9];
  shipToOrderBy?: GetOrdersListParameters[10];
  shipToPlanWindowStartGte?: GetOrdersListParameters[11];
  shipToPlanWindowStartLte?: GetOrdersListParameters[12];
  shipToPlanWindowEndGte?: GetOrdersListParameters[13];
  shipToPlanWindowEndLte?: GetOrdersListParameters[14];
  shipFromOrderBy?: GetOrdersListParameters[15];
  shipFromPlanWindowStartGte?: GetOrdersListParameters[16];
  shipFromPlanWindowStartLte?: GetOrdersListParameters[17];
  shipFromPlanWindowEndGte?: GetOrdersListParameters[18];
  shipFromPlanWindowEndLte?: GetOrdersListParameters[19];
  supplierOrderBy?: GetOrdersListParameters[20];
  supplierName?: GetOrdersListParameters[21];
  releasesOrderBy?: GetOrdersListParameters[22];
  releasesReleasedOntoShipmentId?: GetOrdersListParameters[23];
  options?: GetOrdersListParameters[24];
};
export async function getOrdersList({
  page,
  limit,
  orderBy,
  q,
  statusIn,
  createdAt,
  id,
  orderNumber,
  name,
  references,
  shipToOrderBy,
  shipToPlanWindowStartGte,
  shipToPlanWindowStartLte,
  shipToPlanWindowEndGte,
  shipToPlanWindowEndLte,
  shipFromOrderBy,
  shipFromPlanWindowStartGte,
  shipFromPlanWindowStartLte,
  shipFromPlanWindowEndGte,
  shipFromPlanWindowEndLte,
  supplierOrderBy,
  supplierName,
  releasesOrderBy,
  releasesReleasedOntoShipmentId,
  options
}: GetOrdersListParametersObject = {}) {
  const axiosResponse = await ordersApi.listOrders(
    page,
    limit,
    orderBy,
    q,
    statusIn,
    createdAt,
    id,
    orderNumber,
    name,
    references,
    shipToOrderBy,
    shipToPlanWindowStartGte,
    shipToPlanWindowStartLte,
    shipToPlanWindowEndGte,
    shipToPlanWindowEndLte,
    shipFromOrderBy,
    shipFromPlanWindowStartGte,
    shipFromPlanWindowStartLte,
    shipFromPlanWindowEndGte,
    shipFromPlanWindowEndLte,
    supplierOrderBy,
    supplierName,
    releasesOrderBy,
    releasesReleasedOntoShipmentId,
    options
  );
  return axiosResponse.data;
}
